export enum Scope {
  Country = 'country',
  Area = 'area',
  Restaurant = 'restaurant'
}
